import { PageFrame } from '../../components/PageFrame';
import { SafeExitLink } from './SafeExitLink';

// Shared by SessionIntroduction and PracticeTask: both screens must render
// an indistinguishable generic "not available" state for CONTENT_INELIGIBLE
// — the specific reason (e.g. a teacher-facilitation-note item) must never
// leak to the learner, so this is the one place that copy lives.
export function ContentUnavailableState() {
  return (
    <PageFrame title="Your activity" audience="learner">
      <p className="mt-4 text-lg leading-relaxed text-ink-soft">
        This activity isn't available right now.
      </p>
      <p className="mt-2 text-muted">
        Please check back later, or ask your teacher for help.
      </p>
      <SafeExitLink />
    </PageFrame>
  );
}
